import(/* webpackMode: "eager" */ "/var/www/dev-716-cannabis/app/faq/page.tsx");
